// OPA / SCT › SCT vs actual — the screen's strings in the portal's four languages (2026-10-21).
const en = {
  promiseEdit: "Edit",
  promiseDone: "Done",
  promiseColPerson: "Person",
  promiseColDay: "Will have answered by",
  promiseColState: "Reminder",
  promiseClear: "Clear",
  promiseTitle: "Answered by",
  promiseHint: "if you cannot answer the waiting items now, pick the day you will have them answered by. Until that day the 08:00 reminder in the bell leaves you alone; after it, it comes back.",
  promiseNobody: "Nobody on the list yet — add the people who answer these.",
  promiseNone: "no day set",
  promiseBy: "by {{date}}",
  promisePassed: "{{date}} has passed",
  promiseDate: "Answer-by day for {{name}}",
  promiseSave: "Save",
  promiseRemove: "Take off the list",
  promiseAdd: "Add a person…",
  promiseAddBtn: "Add",
  ctFix: "Correct the CT",
  ctTitle: "The standard itself is wrong: correct it on every order line of this item, part and season that carries it",
  ctNow: "CT now",
  ctActual: "actual",
  ctNew: "New CT",
  ctEffWould: "efficiency would read {{eff}}",
  ctReason: "Why the CT changes (at least 10 characters) — kept beside the answers",
  ctSctNote: "This CT comes from the SCT Summary, which still holds the old figure — correct it there too.",
  ctSave: "Save the new CT",
  ctCancel: "Cancel",
  ctSaved: "CT {{old}} → {{new}} h/pc on {{lines}} order line(s); efficiency now {{eff}}.",
  ctFromSct: "The SCT Summary still holds the old figure — correct it there too.",
  noteCt: "CT corrected",
  presetYear: 'This year',
  preset90: 'Last 90 days',
  preset30: 'Last 30 days',
  stReply: 'Needs reply',
  stMore: 'Needs more explanation',
  stHandled: 'Handled',
  stOk: 'No issue',
  stThin: 'Too few days',
  stAll: 'All',
  basisSct: 'SCT Summary',
  basisWorkbook: 'Workbook',
  checkOver: "The cycle time ({{ct}} h a piece) is longer than the line actually took ({{actual}} man-hours a piece): efficiency {{eff}}, above the {{max}} ceiling. A line cannot beat a standard that is right — check the CT's operations, the hours and pieces recorded, and that the right item was matched.",
  checkUnder: 'The line took {{actual}} man-hours a piece against a cycle time of {{ct}} h: efficiency {{eff}}, below the {{min}} floor. Check whether the CT misses operations this item has, or the line had other work in those hours.',
  colItem: 'Item',
  colPart: 'Part',
  colSap: 'SAP code',
  colBasis: 'CT from',
  colVendor: 'Vendor',
  colDays: 'Days',
  colPieces: 'Pieces',
  colCt: 'CT (h / pc)',
  colActual: 'Actual (man-h / pc)',
  colEff: 'Efficiency',
  colStatus: 'Status',
  aiDecided: "Decided by the AI's reading of the explanation",
  aiAccepts: 'The AI accepts the explanation — the item is handled.',
  aiNotEnough: 'The AI does not find this enough yet — see its note below.',
  savedNoAi: 'Saved. {{err}} Mark it handled yourself if you are satisfied.',
  noteAnswer: 'Explanation',
  noteMark: 'Marked handled',
  noteReopen: 'Reopened',
  aiReading: "The AI's reading of this explanation — it advises, a person may still decide",
  explained: 'Explained.',
  notExplained: 'Not explained.',
  aiNotReviewed: 'The AI did not review this one.',
  autoCheck: 'Automatic check',
  checkMeta: '{{from}} – {{to}} · {{days}} days · {{pieces}} pieces · {{manHours}} man-hours',
  handledByAi: 'Handled once the AI accepted the explanation',
  handledByHand: 'Handled by hand',
  answerPlaceholder: "Why is this item's actual time different from its cycle time? Name the cause — the AI judges whether it explains the gap.",
  min10: 'At least 10 characters',
  sendTitle: 'Save the explanation and let the AI read it',
  sendExplanation: 'Send explanation',
  markTitle: 'Close it without the AI — the note box above, if filled in, is kept with it',
  markHandled: 'Mark as handled',
  reopen: 'Reopen',
  thin_one: 'Only {{count}} production day in this period — fewer than the {{min}} needed before the item is judged.',
  thin_other: 'Only {{count}} production days in this period — fewer than the {{min}} needed before the item is judged.',
  loadingDays: 'Loading the days…',
  dDate: 'Date',
  dVendor: 'Vendor',
  dLine: 'Line',
  dPo: 'PO',
  dPieces: 'Pieces',
  dWorkers: 'Workers',
  dHours: 'Hours',
  dManHPc: 'Man-h / pc',
  dEff: 'Efficiency',
  intro: "Each order line's cycle time against what Daily Output says the line spent: workers × hours ÷ pieces.",
  introBand: 'Efficiency = CT ÷ that; outside {{range}} the item needs an answer (from {{minDays}} production days). The AI reads each answer and says whether it explains the gap — what it writes carries {{tag}}.',
  period: 'Period',
  from: 'From',
  to: 'To',
  vendor: 'Vendor',
  allVendors: 'All vendors',
  reload: 'Reload',
  search: 'Find an item, colour, SAP code, vendor…',
  status: 'Status',
  clear: 'Clear',
  nOfM: '{{n}} of {{total}}',
  skippedNoTime: '{{n}} Daily Output rows in this period have pieces but no workers or hours, and are left out.',
  aiOff: 'The AI is not set up on this server: answers are saved, and closed by hand.',
  measuring: 'Measuring…',
  openCol: 'open',
  nothingHere: 'Nothing here for this period.',
  close: 'Close',
  open: 'Open',
};

const ko = {
  promiseEdit: "편집",
  promiseDone: "완료",
  promiseColPerson: "담당자",
  promiseColDay: "답변 완료 예정일",
  promiseColState: "알림",
  promiseClear: "지우기",
  promiseTitle: "답변 예정일",
  promiseHint: "지금 답변할 수 없다면 답변을 마칠 날짜를 고르세요. 그날까지는 벨의 08:00 알림이 오지 않고, 그 뒤에는 다시 옵니다.",
  promiseNobody: "아직 목록에 아무도 없습니다 — 답변할 사람을 추가하세요.",
  promiseNone: "날짜 미정",
  promiseBy: "{{date}}까지",
  promisePassed: "{{date}} 지남",
  promiseDate: "{{name}}의 답변 예정일",
  promiseSave: "저장",
  promiseRemove: "목록에서 제외",
  promiseAdd: "사람 추가…",
  promiseAddBtn: "추가",
  ctFix: "CT 수정",
  ctTitle: "기준 자체가 틀렸습니다: 이 품목·파트·시즌에서 이 CT를 가진 모든 오더 라인을 수정합니다",
  ctNow: "현재 CT",
  ctActual: "실제",
  ctNew: "새 CT",
  ctEffWould: "효율 {{eff}}이(가) 됩니다",
  ctReason: "CT를 바꾸는 이유 (10자 이상) — 답변 옆에 기록됩니다",
  ctSctNote: "이 CT는 SCT Summary에서 온 값이며, SCT Summary에는 이전 값이 그대로 있습니다 — 거기서도 수정하세요.",
  ctSave: "새 CT 저장",
  ctCancel: "취소",
  ctSaved: "CT {{old}} → {{new}} h/pc, 오더 라인 {{lines}}개 수정; 현재 효율 {{eff}}.",
  ctFromSct: "SCT Summary에는 이전 값이 남아 있습니다 — 거기서도 수정하세요.",
  noteCt: "CT 수정됨",
  presetYear: '올해',
  preset90: '최근 90일',
  preset30: '최근 30일',
  stReply: '답변 필요',
  stMore: '추가 설명 필요',
  stHandled: '처리됨',
  stOk: '문제 없음',
  stThin: '일수 부족',
  stAll: '전체',
  basisSct: 'SCT 요약',
  basisWorkbook: '워크북',
  checkOver: '사이클 타임(개당 {{ct}}시간)이 라인이 실제로 쓴 시간(개당 {{actual}}인시)보다 깁니다: 효율 {{eff}}, 상한 {{max}} 초과. 기준이 맞다면 라인이 기준을 넘어설 수는 없습니다 — CT의 공정, 기록된 시간과 수량, 그리고 올바른 아이템이 연결되었는지 확인하세요.',
  checkUnder: '라인이 사이클 타임 {{ct}}시간에 대해 개당 {{actual}}인시를 썼습니다: 효율 {{eff}}, 하한 {{min}} 미만. CT에 이 아이템의 공정이 빠졌는지, 또는 그 시간에 라인이 다른 작업을 했는지 확인하세요.',
  colItem: '아이템',
  colPart: '파트',
  colSap: 'SAP 코드',
  colBasis: 'CT 출처',
  colVendor: '벤더',
  colDays: '일수',
  colPieces: '수량',
  colCt: 'CT (시간/개)',
  colActual: '실적 (인시/개)',
  colEff: '효율',
  colStatus: '상태',
  aiDecided: 'AI가 설명을 읽고 결정함',
  aiAccepts: 'AI가 설명을 받아들였습니다 — 처리되었습니다.',
  aiNotEnough: 'AI는 아직 충분하지 않다고 봅니다 — 아래 메모를 보세요.',
  savedNoAi: '저장했습니다. {{err}} 납득이 되면 직접 처리됨으로 표시하세요.',
  noteAnswer: '설명',
  noteMark: '처리됨으로 표시',
  noteReopen: '다시 열림',
  aiReading: 'AI의 이 설명에 대한 판단 — 조언일 뿐, 결정은 사람이 할 수 있습니다',
  explained: '설명됨.',
  notExplained: '설명 안 됨.',
  aiNotReviewed: 'AI가 이 설명을 검토하지 않았습니다.',
  autoCheck: '자동 점검',
  checkMeta: '{{from}} – {{to}} · {{days}}일 · {{pieces}}개 · {{manHours}}인시',
  handledByAi: 'AI가 설명을 받아들여 처리됨',
  handledByHand: '수동으로 처리됨',
  answerPlaceholder: '이 아이템의 실제 시간이 사이클 타임과 다른 이유는 무엇인가요? 원인을 적어 주세요 — 차이를 설명하는지는 AI가 판단합니다.',
  min10: '최소 10자',
  sendTitle: '설명을 저장하고 AI가 읽게 합니다',
  sendExplanation: '설명 보내기',
  markTitle: 'AI 없이 닫습니다 — 위 메모 칸에 내용이 있으면 함께 저장됩니다',
  markHandled: '처리됨으로 표시',
  reopen: '다시 열기',
  thin_one: '이 기간의 생산일이 {{count}}일뿐입니다 — 판단에 필요한 {{min}}일보다 적습니다.',
  thin_other: '이 기간의 생산일이 {{count}}일뿐입니다 — 판단에 필요한 {{min}}일보다 적습니다.',
  loadingDays: '일별 데이터를 불러오는 중…',
  dDate: '날짜',
  dVendor: '벤더',
  dLine: '라인',
  dPo: 'PO',
  dPieces: '수량',
  dWorkers: '작업자',
  dHours: '시간',
  dManHPc: '인시/개',
  dEff: '효율',
  intro: '각 오더 라인의 사이클 타임을 Daily Output 기준으로 라인이 실제로 쓴 시간(작업자 × 시간 ÷ 수량)과 비교합니다.',
  introBand: '효율 = CT ÷ 그 값이며, {{range}} 범위를 벗어나면 답변이 필요합니다(생산일 {{minDays}}일 이상부터). AI가 각 답변을 읽고 차이를 설명하는지 판단하며, AI가 쓴 내용에는 {{tag}} 표시가 붙습니다.',
  period: '기간',
  from: '시작일',
  to: '종료일',
  vendor: '벤더',
  allVendors: '전체 벤더',
  reload: '새로고침',
  search: '아이템, 색상, SAP 코드, 벤더 검색…',
  status: '상태',
  clear: '초기화',
  nOfM: '{{total}}개 중 {{n}}개',
  skippedNoTime: '이 기간의 Daily Output 행 {{n}}개는 수량은 있지만 작업자나 시간이 없어 제외되었습니다.',
  aiOff: '이 서버에는 AI가 설정되어 있지 않습니다: 답변은 저장되고 수동으로 닫습니다.',
  measuring: '측정 중…',
  openCol: '열기',
  nothingHere: '이 기간에는 항목이 없습니다.',
  close: '닫기',
  open: '열기',
};

const vi = {
  promiseEdit: "Sửa",
  promiseDone: "Xong",
  promiseColPerson: "Người",
  promiseColDay: "Hẹn trả lời xong trước",
  promiseColState: "Nhắc",
  promiseClear: "Xóa ngày",
  promiseTitle: "Hẹn xong trước",
  promiseHint: "nếu chưa trả lời ngay được các mục đang chờ, hãy chọn ngày sẽ trả lời xong. Đến ngày đó chuông nhắc lúc 08:00 sẽ không nhắc bạn; qua ngày đó thì nhắc lại.",
  promiseNobody: "Chưa có ai trong danh sách — thêm những người trả lời các mục này.",
  promiseNone: "chưa hẹn",
  promiseBy: "hẹn {{date}}",
  promisePassed: "đã quá {{date}}",
  promiseDate: "Ngày hẹn của {{name}}",
  promiseSave: "Lưu",
  promiseRemove: "Bỏ khỏi danh sách",
  promiseAdd: "Thêm người…",
  promiseAddBtn: "Thêm",
  ctFix: "Sửa CT",
  ctTitle: "Chính tiêu chuẩn bị sai: sửa trên mọi dòng đơn của mã, phần và mùa này đang mang CT đó",
  ctNow: "CT hiện tại",
  ctActual: "thực tế",
  ctNew: "CT mới",
  ctEffWould: "hiệu suất sẽ là {{eff}}",
  ctReason: "Lý do đổi CT (ít nhất 10 ký tự) — lưu cạnh các câu trả lời",
  ctSctNote: "CT này lấy từ SCT Summary, nơi vẫn còn số cũ — nhớ sửa ở đó nữa.",
  ctSave: "Lưu CT mới",
  ctCancel: "Hủy",
  ctSaved: "CT {{old}} → {{new}} h/sp trên {{lines}} dòng đơn; hiệu suất giờ là {{eff}}.",
  ctFromSct: "SCT Summary vẫn còn số cũ — nhớ sửa ở đó nữa.",
  noteCt: "Đã sửa CT",
  presetYear: 'Năm nay',
  preset90: '90 ngày qua',
  preset30: '30 ngày qua',
  stReply: 'Cần trả lời',
  stMore: 'Cần giải thích thêm',
  stHandled: 'Đã xử lý',
  stOk: 'Không có vấn đề',
  stThin: 'Quá ít ngày',
  stAll: 'Tất cả',
  basisSct: 'Tổng hợp SCT',
  basisWorkbook: 'Workbook',
  checkOver: 'Thời gian chu kỳ ({{ct}} giờ mỗi sản phẩm) dài hơn thời gian chuyền thực tế dùng ({{actual}} giờ công mỗi sản phẩm): hiệu suất {{eff}}, vượt mức trần {{max}}. Chuyền không thể vượt một định mức đúng — hãy kiểm tra các công đoạn của CT, số giờ và số lượng đã ghi, và mặt hàng có được gắn đúng không.',
  checkUnder: 'Chuyền dùng {{actual}} giờ công mỗi sản phẩm so với thời gian chu kỳ {{ct}} giờ: hiệu suất {{eff}}, dưới mức sàn {{min}}. Hãy kiểm tra CT có thiếu công đoạn mà mặt hàng này có không, hoặc trong những giờ đó chuyền có làm việc khác không.',
  colItem: 'Mặt hàng',
  colPart: 'Bộ phận',
  colSap: 'Mã SAP',
  colBasis: 'CT lấy từ',
  colVendor: 'Nhà cung cấp',
  colDays: 'Số ngày',
  colPieces: 'Số lượng',
  colCt: 'CT (giờ / sp)',
  colActual: 'Thực tế (giờ công / sp)',
  colEff: 'Hiệu suất',
  colStatus: 'Trạng thái',
  aiDecided: 'Do AI quyết định sau khi đọc phần giải thích',
  aiAccepts: 'AI chấp nhận phần giải thích — mặt hàng đã được xử lý.',
  aiNotEnough: 'AI thấy như vậy chưa đủ — xem ghi chú của AI bên dưới.',
  savedNoAi: 'Đã lưu. {{err}} Nếu thấy hợp lý, hãy tự đánh dấu đã xử lý.',
  noteAnswer: 'Giải thích',
  noteMark: 'Đánh dấu đã xử lý',
  noteReopen: 'Mở lại',
  aiReading: 'Nhận định của AI về phần giải thích này — AI chỉ tư vấn, người dùng vẫn có thể quyết định',
  explained: 'Đã giải thích được.',
  notExplained: 'Chưa giải thích được.',
  aiNotReviewed: 'AI chưa xem xét phần này.',
  autoCheck: 'Kiểm tra tự động',
  checkMeta: '{{from}} – {{to}} · {{days}} ngày · {{pieces}} sản phẩm · {{manHours}} giờ công',
  handledByAi: 'Đã xử lý khi AI chấp nhận phần giải thích',
  handledByHand: 'Xử lý thủ công',
  answerPlaceholder: 'Vì sao thời gian thực tế của mặt hàng này khác thời gian chu kỳ? Nêu nguyên nhân — AI sẽ đánh giá xem có giải thích được chênh lệch không.',
  min10: 'Ít nhất 10 ký tự',
  sendTitle: 'Lưu phần giải thích và để AI đọc',
  sendExplanation: 'Gửi giải thích',
  markTitle: 'Đóng mà không cần AI — nội dung ô ghi chú phía trên, nếu có, được lưu kèm',
  markHandled: 'Đánh dấu đã xử lý',
  reopen: 'Mở lại',
  thin_one: 'Chỉ có {{count}} ngày sản xuất trong kỳ này — ít hơn {{min}} ngày cần có trước khi đánh giá mặt hàng.',
  thin_other: 'Chỉ có {{count}} ngày sản xuất trong kỳ này — ít hơn {{min}} ngày cần có trước khi đánh giá mặt hàng.',
  loadingDays: 'Đang tải các ngày…',
  dDate: 'Ngày',
  dVendor: 'Nhà cung cấp',
  dLine: 'Chuyền',
  dPo: 'PO',
  dPieces: 'Số lượng',
  dWorkers: 'Công nhân',
  dHours: 'Giờ',
  dManHPc: 'Giờ công / sp',
  dEff: 'Hiệu suất',
  intro: 'Thời gian chu kỳ của từng dòng đơn hàng so với thời gian chuyền thực tế dùng theo Sản lượng ngày: công nhân × giờ ÷ số lượng.',
  introBand: 'Hiệu suất = CT ÷ giá trị đó; ngoài khoảng {{range}} thì mặt hàng cần được giải thích (từ {{minDays}} ngày sản xuất). AI đọc từng câu trả lời và cho biết có giải thích được chênh lệch không — nội dung AI viết có dấu {{tag}}.',
  period: 'Kỳ',
  from: 'Từ',
  to: 'Đến',
  vendor: 'Nhà cung cấp',
  allVendors: 'Tất cả nhà cung cấp',
  reload: 'Tải lại',
  search: 'Tìm mặt hàng, màu, mã SAP, nhà cung cấp…',
  status: 'Trạng thái',
  clear: 'Xóa lọc',
  nOfM: '{{n}} / {{total}}',
  skippedNoTime: '{{n}} dòng Sản lượng ngày trong kỳ này có số lượng nhưng không có công nhân hoặc giờ, nên bị loại ra.',
  aiOff: 'AI chưa được thiết lập trên máy chủ này: câu trả lời được lưu và đóng thủ công.',
  measuring: 'Đang đo…',
  openCol: 'mở',
  nothingHere: 'Không có gì trong kỳ này.',
  close: 'Đóng',
  open: 'Mở',
};

const zh = {
  promiseEdit: "编辑",
  promiseDone: "完成",
  promiseColPerson: "人员",
  promiseColDay: "预计回复完成日期",
  promiseColState: "提醒",
  promiseClear: "清除",
  promiseTitle: "预计完成日期",
  promiseHint: "如果现在无法回复待处理项，请选择完成回复的日期。在此之前铃铛的 08:00 提醒不会打扰你；过了这一天会再次提醒。",
  promiseNobody: "名单中还没有人——请添加负责回复的人。",
  promiseNone: "未设日期",
  promiseBy: "{{date}} 前",
  promisePassed: "已过 {{date}}",
  promiseDate: "{{name}} 的回复日期",
  promiseSave: "保存",
  promiseRemove: "移出名单",
  promiseAdd: "添加人员…",
  promiseAddBtn: "添加",
  ctFix: "修改 CT",
  ctTitle: "标准本身有误：在此物料、部件和季节中带有该 CT 的所有订单行上修改",
  ctNow: "当前 CT",
  ctActual: "实际",
  ctNew: "新 CT",
  ctEffWould: "效率将为 {{eff}}",
  ctReason: "修改 CT 的原因（至少 10 个字符）——与回复一同保存",
  ctSctNote: "此 CT 来自 SCT Summary，那里仍是旧数值——请在那里一并修改。",
  ctSave: "保存新 CT",
  ctCancel: "取消",
  ctSaved: "CT {{old}} → {{new}} h/件，共 {{lines}} 条订单行；当前效率 {{eff}}。",
  ctFromSct: "SCT Summary 中仍是旧数值——请在那里一并修改。",
  noteCt: "已修改 CT",
  presetYear: '今年',
  preset90: '最近 90 天',
  preset30: '最近 30 天',
  stReply: '待回复',
  stMore: '需补充说明',
  stHandled: '已处理',
  stOk: '无问题',
  stThin: '天数不足',
  stAll: '全部',
  basisSct: 'SCT 汇总',
  basisWorkbook: '工作簿',
  checkOver: '周期时间（每件 {{ct}} 小时）长于产线实际用时（每件 {{actual}} 人时）：效率 {{eff}}，高于上限 {{max}}。若标准正确，产线不可能超越它——请检查 CT 的工序、记录的工时和件数，以及是否关联了正确的品项。',
  checkUnder: '产线每件用了 {{actual}} 人时，周期时间为 {{ct}} 小时：效率 {{eff}}，低于下限 {{min}}。请检查 CT 是否缺少该品项实际有的工序，或产线在这些工时内是否有其他工作。',
  colItem: '品项',
  colPart: '部件',
  colSap: 'SAP 代码',
  colBasis: 'CT 来源',
  colVendor: '供应商',
  colDays: '天数',
  colPieces: '件数',
  colCt: 'CT（小时/件）',
  colActual: '实际（人时/件）',
  colEff: '效率',
  colStatus: '状态',
  aiDecided: '由 AI 根据说明判定',
  aiAccepts: 'AI 接受该说明——此品项已处理。',
  aiNotEnough: 'AI 认为说明尚不充分——请看下方的备注。',
  savedNoAi: '已保存。{{err}} 如您认可，请自行标记为已处理。',
  noteAnswer: '说明',
  noteMark: '已标记为处理',
  noteReopen: '已重新打开',
  aiReading: 'AI 对此说明的判断——仅供参考，仍可由人决定',
  explained: '已解释。',
  notExplained: '未解释。',
  aiNotReviewed: 'AI 未审阅此条。',
  autoCheck: '自动检查',
  checkMeta: '{{from}} – {{to}} · {{days}} 天 · {{pieces}} 件 · {{manHours}} 人时',
  handledByAi: 'AI 接受说明后已处理',
  handledByHand: '人工处理',
  answerPlaceholder: '为什么此品项的实际时间与周期时间不同？请写明原因——由 AI 判断是否能解释差异。',
  min10: '至少 10 个字符',
  sendTitle: '保存说明并交由 AI 阅读',
  sendExplanation: '发送说明',
  markTitle: '不经 AI 直接关闭——上方备注框如有内容会一并保存',
  markHandled: '标记为已处理',
  reopen: '重新打开',
  thin_one: '此期间仅有 {{count}} 个生产日——少于判定所需的 {{min}} 天。',
  thin_other: '此期间仅有 {{count}} 个生产日——少于判定所需的 {{min}} 天。',
  loadingDays: '正在加载每日数据…',
  dDate: '日期',
  dVendor: '供应商',
  dLine: '产线',
  dPo: 'PO',
  dPieces: '件数',
  dWorkers: '工人',
  dHours: '工时',
  dManHPc: '人时/件',
  dEff: '效率',
  intro: '每条订单行的周期时间，对比每日产量所记录的产线实际用时：工人 × 工时 ÷ 件数。',
  introBand: '效率 = CT ÷ 该值；超出 {{range}} 时需要说明（从 {{minDays}} 个生产日起）。AI 会阅读每条说明并判断是否能解释差异——AI 写的内容带有 {{tag}} 标记。',
  period: '期间',
  from: '开始',
  to: '结束',
  vendor: '供应商',
  allVendors: '全部供应商',
  reload: '重新加载',
  search: '查找品项、颜色、SAP 代码、供应商…',
  status: '状态',
  clear: '清除',
  nOfM: '{{n}} / {{total}}',
  skippedNoTime: '此期间有 {{n}} 行每日产量记录有件数但没有工人或工时，已排除。',
  aiOff: '此服务器未设置 AI：说明会被保存，并由人工关闭。',
  measuring: '计算中…',
  openCol: '展开',
  nothingHere: '此期间没有内容。',
  close: '收起',
  open: '展开',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "promiseEdit": "Modifier",
  "promiseDone": "Terminé",
  "promiseColPerson": "Personne",
  "promiseColDay": "Aura répondu d'ici le",
  "promiseColState": "Rappel",
  "promiseClear": "Effacer",
  "promiseTitle": "Réponse d'ici le",
  "promiseHint": "si vous ne pouvez pas répondre maintenant aux éléments en attente, choisissez le jour d'ici lequel vous y aurez répondu. Jusqu'à ce jour, le rappel de 08:00 dans la cloche ne vous sollicite pas ; ensuite, il revient.",
  "promiseNobody": "Personne dans la liste pour l'instant — ajoutez les personnes qui répondent à ces éléments.",
  "promiseNone": "aucun jour défini",
  "promiseBy": "d'ici le {{date}}",
  "promisePassed": "{{date}} est dépassé",
  "promiseDate": "Jour limite de réponse pour {{name}}",
  "promiseSave": "Enregistrer",
  "promiseRemove": "Retirer de la liste",
  "promiseAdd": "Ajouter une personne…",
  "promiseAddBtn": "Ajouter",
  "ctFix": "Corriger le CT",
  "ctTitle": "Le standard lui-même est erroné : corrigez-le sur chaque ligne de commande de cet article, de cette pièce et de cette saison qui le porte",
  "ctNow": "CT actuel",
  "ctActual": "réel",
  "ctNew": "Nouveau CT",
  "ctEffWould": "l'efficacité serait de {{eff}}",
  "ctReason": "Pourquoi le CT change (10 caractères minimum) — conservé à côté des réponses",
  "ctSctNote": "Ce CT provient de SCT Summary, qui contient encore l'ancien chiffre — corrigez-le aussi là-bas.",
  "ctSave": "Enregistrer le nouveau CT",
  "ctCancel": "Annuler",
  "ctSaved": "CT {{old}} → {{new}} h/pc sur {{lines}} ligne(s) de commande ; efficacité désormais {{eff}}.",
  "ctFromSct": "SCT Summary contient encore l'ancien chiffre — corrigez-le aussi là-bas.",
  "noteCt": "CT corrigé",
  "presetYear": "Cette année",
  "preset90": "90 derniers jours",
  "preset30": "30 derniers jours",
  "stReply": "Réponse requise",
  "stMore": "Explication complémentaire requise",
  "stHandled": "Traité",
  "stOk": "Aucun problème",
  "stThin": "Trop peu de jours",
  "stAll": "Tout",
  "basisSct": "Synthèse SCT",
  "basisWorkbook": "Classeur",
  "checkOver": "Le temps de cycle ({{ct}} h la pièce) est supérieur au temps réellement pris par la ligne ({{actual}} heures-homme la pièce) : efficacité {{eff}}, au-dessus du plafond de {{max}}. Une ligne ne peut pas faire mieux qu'un standard correct — vérifiez les opérations du CT, les heures et les pièces enregistrées, et que le bon article a été associé.",
  "checkUnder": "La ligne a pris {{actual}} heures-homme la pièce pour un temps de cycle de {{ct}} h : efficacité {{eff}}, en dessous du plancher de {{min}}. Vérifiez si le CT omet des opérations propres à cet article, ou si la ligne avait d'autres travaux sur ces heures.",
  "colItem": "Article",
  "colPart": "Pièce",
  "colSap": "Code SAP",
  "colBasis": "CT issu de",
  "colVendor": "Fournisseur",
  "colDays": "Jours",
  "colPieces": "Pièces",
  "colCt": "CT (h / pc)",
  "colActual": "Réel (h-homme / pc)",
  "colEff": "Efficacité",
  "colStatus": "Statut",
  "aiDecided": "Décidé d'après la lecture de l'explication par l'AI",
  "aiAccepts": "L'AI accepte l'explication — l'élément est traité.",
  "aiNotEnough": "L'AI ne la juge pas encore suffisante — voir sa note ci-dessous.",
  "savedNoAi": "Enregistré. {{err}} Marquez-le comme traité vous-même si vous êtes satisfait.",
  "noteAnswer": "Explication",
  "noteMark": "Marqué comme traité",
  "noteReopen": "Rouvert",
  "aiReading": "Lecture de cette explication par l'AI — elle conseille, une personne peut encore trancher",
  "explained": "Expliqué.",
  "notExplained": "Non expliqué.",
  "aiNotReviewed": "L'AI n'a pas examiné celui-ci.",
  "autoCheck": "Contrôle automatique",
  "checkMeta": "{{from}} – {{to}} · {{days}} jours · {{pieces}} pièces · {{manHours}} heures-homme",
  "handledByAi": "Traité dès que l'AI a accepté l'explication",
  "handledByHand": "Traité manuellement",
  "answerPlaceholder": "Pourquoi le temps réel de cet article diffère-t-il de son temps de cycle ? Indiquez la cause — l'AI juge si elle explique l'écart.",
  "min10": "10 caractères minimum",
  "sendTitle": "Enregistrer l'explication et la faire lire par l'AI",
  "sendExplanation": "Envoyer l'explication",
  "markTitle": "Clôturer sans l'AI — la zone de note ci-dessus, si elle est remplie, est conservée avec",
  "markHandled": "Marquer comme traité",
  "reopen": "Rouvrir",
  "thin_one": "Seulement {{count}} jour de production sur cette période — moins que les {{min}} nécessaires avant que l'article soit jugé.",
  "thin_other": "Seulement {{count}} jours de production sur cette période — moins que les {{min}} nécessaires avant que l'article soit jugé.",
  "loadingDays": "Chargement des jours…",
  "dDate": "Date",
  "dVendor": "Fournisseur",
  "dLine": "Ligne",
  "dPo": "PO",
  "dPieces": "Pièces",
  "dWorkers": "Opérateurs",
  "dHours": "Heures",
  "dManHPc": "H-homme / pc",
  "dEff": "Efficacité",
  "intro": "Le temps de cycle de chaque ligne de commande comparé à ce que Daily Output indique que la ligne a consommé : opérateurs × heures ÷ pièces.",
  "introBand": "Efficacité = CT ÷ ce résultat ; en dehors de {{range}}, l'article nécessite une réponse (à partir de {{minDays}} jours de production). L'AI lit chaque réponse et indique si elle explique l'écart — ce qu'elle écrit porte {{tag}}.",
  "period": "Période",
  "from": "Du",
  "to": "Au",
  "vendor": "Fournisseur",
  "allVendors": "Tous les fournisseurs",
  "reload": "Recharger",
  "search": "Rechercher un article, une couleur, un code SAP, un fournisseur…",
  "status": "Statut",
  "clear": "Effacer",
  "nOfM": "{{n}} sur {{total}}",
  "skippedNoTime": "{{n}} lignes de Daily Output sur cette période ont des pièces mais ni opérateurs ni heures, et sont exclues.",
  "aiOff": "L'AI n'est pas configurée sur ce serveur : les réponses sont enregistrées et clôturées manuellement.",
  "measuring": "Mesure en cours…",
  "openCol": "ouvert",
  "nothingHere": "Rien ici pour cette période.",
  "close": "Fermer",
  "open": "Ouvrir"
};
const ja = {
  "promiseEdit": "編集",
  "promiseDone": "完了",
  "promiseColPerson": "担当者",
  "promiseColDay": "回答予定日",
  "promiseColState": "リマインダー",
  "promiseClear": "クリア",
  "promiseTitle": "回答期限",
  "promiseHint": "回答待ちの項目にすぐ回答できない場合は、回答できる日を選択してください。その日まで、ベルに届く08:00のリマインダーは停止します。その日を過ぎると再開します。",
  "promiseNobody": "リストにはまだ誰もいません。これらに回答する担当者を追加してください。",
  "promiseNone": "日付未設定",
  "promiseBy": "{{date}}まで",
  "promisePassed": "{{date}}を過ぎました",
  "promiseDate": "{{name}}さんの回答期限日",
  "promiseSave": "保存",
  "promiseRemove": "リストから外す",
  "promiseAdd": "担当者を追加…",
  "promiseAddBtn": "追加",
  "ctFix": "CTを修正",
  "ctTitle": "標準そのものが誤っています。このアイテム・部位・シーズンのCTを持つすべての注文明細で修正します",
  "ctNow": "現在のCT",
  "ctActual": "実績",
  "ctNew": "新しいCT",
  "ctEffWould": "効率は{{eff}}になります",
  "ctReason": "CTを変更する理由（10文字以上）：回答とあわせて保存されます",
  "ctSctNote": "このCTはSCT Summaryから取得されており、そこにはまだ古い数値が残っています。そちらも修正してください。",
  "ctSave": "新しいCTを保存",
  "ctCancel": "キャンセル",
  "ctSaved": "注文明細{{lines}}件でCTを{{old}}→{{new}} h/pcに変更しました。効率は{{eff}}になりました。",
  "ctFromSct": "SCT Summaryにはまだ古い数値が残っています。そちらも修正してください。",
  "noteCt": "CTを修正",
  "presetYear": "今年",
  "preset90": "過去90日間",
  "preset30": "過去30日間",
  "stReply": "要回答",
  "stMore": "説明の追加が必要",
  "stHandled": "対応済み",
  "stOk": "問題なし",
  "stThin": "日数不足",
  "stAll": "すべて",
  "basisSct": "SCTサマリー",
  "basisWorkbook": "ワークブック",
  "checkOver": "サイクルタイム（1個あたり{{ct}}h）が、ラインが実際にかけた時間（1個あたり{{actual}}人時）より長くなっています。効率{{eff}}は上限{{max}}を超えています。正しい標準を上回るラインはありえません。CTの工程、記録された時間と数量、正しいアイテムと紐付いているかを確認してください。",
  "checkUnder": "ラインは1個あたり{{actual}}人時かかり、サイクルタイムは{{ct}}hでした。効率{{eff}}は下限{{min}}を下回っています。このアイテムにある工程がCTに含まれていないか、その時間帯にラインが別の作業をしていないかを確認してください。",
  "colItem": "アイテム",
  "colPart": "部位",
  "colSap": "SAPコード",
  "colBasis": "CTの出典",
  "colVendor": "仕入先",
  "colDays": "日数",
  "colPieces": "数量",
  "colCt": "CT（h／個）",
  "colActual": "実績（人時／個）",
  "colEff": "効率",
  "colStatus": "ステータス",
  "aiDecided": "説明に対するAIの判定により決定",
  "aiAccepts": "AIは説明を受け入れました。このアイテムは対応済みです。",
  "aiNotEnough": "AIはまだ十分とは判断していません。下のAIのメモをご確認ください。",
  "savedNoAi": "保存しました。{{err}} 納得できる場合は、ご自身で対応済みにしてください。",
  "noteAnswer": "説明",
  "noteMark": "対応済みにしました",
  "noteReopen": "再開しました",
  "aiReading": "この説明に対するAIの判定。AIは助言を行い、最終判断は担当者が行えます",
  "explained": "説明は十分です。",
  "notExplained": "説明が不十分です。",
  "aiNotReviewed": "AIはこの項目を確認していません。",
  "autoCheck": "自動チェック",
  "checkMeta": "{{from}}〜{{to}}・{{days}}日・{{pieces}}個・{{manHours}}人時",
  "handledByAi": "AIが説明を受け入れて対応済み",
  "handledByHand": "手動で対応済み",
  "answerPlaceholder": "このアイテムの実績時間がサイクルタイムと異なるのはなぜですか？原因を記入してください。その原因で差が説明できるかをAIが判断します。",
  "min10": "10文字以上",
  "sendTitle": "説明を保存し、AIに読み込ませる",
  "sendExplanation": "説明を送信",
  "markTitle": "AIを使わずに完了にします。上のメモ欄に入力があれば、一緒に保存されます",
  "markHandled": "対応済みにする",
  "reopen": "再開",
  "thin_one": "この期間の生産日は{{count}}日のみです。アイテムを判定するために必要な{{min}}日に満たません。",
  "thin_other": "この期間の生産日は{{count}}日のみです。アイテムを判定するために必要な{{min}}日に満たません。",
  "loadingDays": "日別データを読み込み中…",
  "dDate": "日付",
  "dVendor": "仕入先",
  "dLine": "ライン",
  "dPo": "PO",
  "dPieces": "数量",
  "dWorkers": "作業人数",
  "dHours": "時間",
  "dManHPc": "人時／個",
  "dEff": "効率",
  "intro": "各注文明細のサイクルタイムを、Daily Outputに記録されたラインの実績（作業人数×時間÷数量）と比較します。",
  "introBand": "効率＝CT÷上記の値。{{range}}の範囲外のアイテムには回答が必要です（生産日が{{minDays}}日以上ある場合）。AIが各回答を読み、差を説明できているかを判断します。AIが書いた内容には{{tag}}が付きます。",
  "period": "期間",
  "from": "開始",
  "to": "終了",
  "vendor": "仕入先",
  "allVendors": "すべての仕入先",
  "reload": "再読み込み",
  "search": "アイテム、カラー、SAPコード、仕入先を検索…",
  "status": "ステータス",
  "clear": "クリア",
  "nOfM": "{{total}}件中{{n}}件",
  "skippedNoTime": "この期間のDaily Output {{n}}行は、数量はあるものの作業人数または時間がないため、対象外としています。",
  "aiOff": "このサーバーではAIが設定されていません。回答は保存され、手動で完了にします。",
  "measuring": "測定中…",
  "openCol": "未対応",
  "nothingHere": "この期間に該当するものはありません。",
  "close": "閉じる",
  "open": "開く"
};

const dictionary = { ns: 'xSctActual', en, ko, vi, zh, fr, ja };

export default dictionary;
